import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Pencil, Trash, Plus } from "tabler-icons-react";
import feature from "../assets/meeting.png";
import { MenuContext } from "../context/menuContext";

function Features() {
	const { mobileMenu } = useContext(MenuContext);

	return (
		<div
			className={
				mobileMenu
					? "overflow-y-hidden absolute md:left-64 md:top-0 md:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
					: "absolute top-[3rem] md:left-[13rem] lg:left-64 md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
			}>
			<div className="flex justify-between items-baseline px-5 border-b border-b-slate-100 dark:border-b-darkborder">
				<h1 className="text-slate-500 dark:text-darktext uppercase font-semibold">
					All Features <span>(3)</span>
				</h1>
				<Link
					to="/features/new"
					className="flex items-center border border-sky-200 dark:border-darkborder px-3 py-1 text-slate-600 dark:text-darkbtntext rounded-sm hover:bg-sky-500 hover:dark:bg-darkbtnhover hover:text-white hover:dark:text-darkbtntext transition-all duration-150 ease-in-out">
					<Plus className="mr-1" /> Add feature
				</Link>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-2 md:gap-2 mt-3 px-5">
				<div className="shadow-sm rounded-md bg-white dark:bg-darkbg dark:border dark:border-darkborder">
					<img src={feature} alt="event" className="rounded-t-md w-full h-44" />
					<div className="py-3 px-2 border-b dark:border-b-darkborder">
						<span className="font-medium w-2/3 truncate dark:text-darktext">
							Tech Talk: Verudela Beach
						</span>
					</div>
					<p className="text-sm text-slate-600 dark:text-darktext py-[.35rem] leading-relaxed px-2 line-clamp-4 border-b dark:border-b-darkborder">
						Completely renovated for the season 2020, Arena Verudela Bech
						Apartments are fully equipped and modernly furnished 4-star
						self-service apartments located on the Adriatic coastline by one of
						the most beautiful beaches in Pula.
					</p>
					<div className="flex py-2 pr-2 space-x-3">
						<Link to="/features/:id" className="ml-auto">
							<Pencil className="border border-slate-300 hover:bg-sky-100 hover:dark:bg-darkbtnhover transition-all duration-150 ease-in-out p-1 rounded-md text-sky-500" />
						</Link>
						<Trash className="cursor-pointer border border-slate-300 hover:bg-sky-100 hover:dark:bg-darkbtnhover transition-all duration-150 ease-in-out p-1 rounded-md text-red-500" />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Features;
